const TRACKING_ID = "G-P2DEY76SQ3";

let gaPromise;
let initialized = false;

export const getAnalyticsConsent = () => {
  if (typeof window === "undefined") return "unknown";
  return window.localStorage.getItem("analytics_consent");
};

export const setAnalyticsConsent = (value) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem("analytics_consent", value);
};

export const initAnalytics = async () => {
  if (typeof window === "undefined") return null;
  if (getAnalyticsConsent() !== "granted") return null;

  if (!gaPromise) {
    gaPromise = import("react-ga4").then((mod) => mod.default || mod);
  }

  const ReactGA = await gaPromise;
  if (!initialized) {
    ReactGA.initialize(TRACKING_ID);
    initialized = true;
  }
  return ReactGA;
};

export const trackPageview = async (path, title) => {
  const ReactGA = await initAnalytics();
  if (!ReactGA) return;

  ReactGA.send({
    hitType: "pageview",
    page: path || window.location.pathname,
    title,
  });
};
